import React from "react";
import {Col, Row} from "reactstrap";
import {DollarSign, Hash, TrendingUp, Users} from "react-feather";
import WidgetInformationWithIcon from "../../../../CommonComponents/Dashboard/DashboardWidget";
import type {Board} from "../../Types/BoardTypes";

interface BoardDashboardProps {
    board: Board;
}

const BoardDashboard = ({board}: BoardDashboardProps) => {
    const participantsCount = board.statistics?.participants_count ?? board.participants_count ?? 0;
    const value = board.statistics?.value ?? board.value ?? 0;
    const points = board.statistics?.points ?? board.points ?? 0;
    const soldNumbers = board.statistics?.sold_numbers ?? board.sold_numbers ?? 0;

    return (
        <div>
            <Row>
                <Col xxl='auto' xl='3' sm='6' className='box-col-6'>
                    <Row>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Participants',
                                gros: 5,
                                total: participantsCount,
                                color: 'secondary',
                                icon: <Users size={16} color={'purple'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Value',
                                gros: 50,
                                total: value,
                                color: 'primary',
                                icon: <DollarSign size={16} color={'orange'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Points',
                                gros: 20,
                                total: points,
                                color: 'success',
                                icon: <TrendingUp size={16} color={'green'}/>,
                            }}/>
                        </Col>
                        <Col xl='6'>
                            <WidgetInformationWithIcon data={{
                                title: 'Sold Numbers',
                                gros: 10,
                                total: soldNumbers,
                                color: 'default',
                                icon: <Hash size={16} color={'blue'}/>,
                            }}/>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default BoardDashboard;

